import { useTranslation } from 'react-i18next';

import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { I18NextNS } from 'src/models/Language.model';
import { EyesPosition } from 'src/models/Session.model';

import InfoCardTemplate from './InfoCardTemplate';

type BadQualityInformationCardProps = {
  eye: EyesPosition;
};

export default function BadQualityInfoCard({
  eye,
}: BadQualityInformationCardProps) {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'newExam.analyzingModal.infoCards.badQuality',
  });
  const secondaryEye = eye === EyesPosition.BOTH ? t(eye) : `the ${t(eye)}`;

  return (
    <InfoCardTemplate
      icon={<FontAwesomeIcon icon={faCamera} className="text-primary" />}
      backgroundColor="primary-100"
      borderColor="primary"
      primaryText={t('primary', { eye: t(eye) })}
      secondaryText={t('secondary', { eye: secondaryEye })}
      dataTest={`info-bad-quality-${String(eye).toLowerCase()}`}
    />
  );
}
